<div
  class="box flex h-full max-w-[350px] flex-col rounded-lg border border-gray-300 p-4 shadow-md"
  *transloco="let t"
>
  <!--  header-->
  <div class="mb-3 flex min-h-[48px] justify-between">
    <div class="flex items-center">
      <mat-icon class="text-md mr-2 text-orange">description</mat-icon>
      <h3 class="text-md line-clamp-2 font-semibold text-primary">
        {{ t('portal.courses.courseTitleKeys.' + course.name + '.name') }}
      </h3>
    </div>
  </div>
  <!--  body-->
  <p class="text-md h- mb-3 line-clamp-3 h-[72px] text-grey">
    {{ t('portal.courses.courseTitleKeys.' + course.name + '.description') }}
  </p>
  <!--  Footer-->
  <div class="flex flex-col justify-between gap-4">
    @if (course.id) {
      <app-link
        [description]="t('portal.courses.previewDialog.activatorBtn')"
        [clickAction]="onCoursePreviewClick(course.id)"
      >
        <mat-icon class="text-base font-semibold text-blue">
          open_in_new
        </mat-icon>
      </app-link>
    }
    <div class="flex w-full space-x-4">
      <app-primary-button
        class="flex-1"
        [text]="t('portal.trainings.builder.courseGalleryButtons.select')"
        [type]="buttonType.LEADING_ADD_ICON"
        (buttonClicked)="addCourseToLearningPlan()"
      />
    </div>
  </div>
</div>
